import cs from 'classnames';

import type { IButtonProps } from '@/DesignSystem/Model/DataModel';

export const generateButtonClassNames = ({
  className,
  disabled,
  iconButton,
  isLoading,
  radius,
  color,
  size,
  variant,
  bold,
}: IButtonProps) => {
  return cs(
    'ui__button',
    variant && `ui__button--variant-${variant}`,
    size && `ui__button--size-${size}`,
    color && `ui__button--color-${color}`,
    radius && `ui__button--radius-${radius}`,
    isLoading && `ui__button--is-loading`,
    disabled && `ui__button--is-disabled`,
    iconButton && `ui__button--icon-button`,
    bold && `ui__button--bold`,
    className,
  );
};
